import React, { useCallback, useState } from 'react';
import { bool, shape } from 'prop-types';

import ICON_PRIME from 'Icon/MenuProfile/svg/IconPrime';
import primeAvatarImg from 'Icon/MenuProfile/PrimeAvatar.png';
import IconWhatsapp from 'Icon/svg/IconWhatsapp';
import { WA_MEMBER_PREMIUM_MESSAGE } from '@config/constanta';
import { Button, IconSvg } from '@ajaibid/components';

import { sanitizeHtml } from '@ajaibid/utils';
import {
  styMembershipModal,
  styPrimeBadgeTrial,
  styPrimeContent,
  styPrimeHeader,
  styPrimeManager,
  styPrimeName,
  styPrimeRightHeader,
  styPrimeText,
  styPrimeTrialInfo,
  styPrimeTrialTitle,
  styPrimeWrapper,
} from './style';
import PopupDetail from './PopupDetail';

const Prime = ({ isPremiumTrial, membershipData, primeTrialData }) => {
  const [infoPrimeData, setInfoPrimeData] = useState({
    isOpen: false,
    img: null,
    title: '',
    content: '',
  });

  const hideModal = useCallback(() => {
    setInfoPrimeData({ ...infoPrimeData, isOpen: false });
  });

  const createMarkup = () => ({
    __html: sanitizeHtml(membershipData?.membership_benefit),
  });

  const clickToCallRm = () => {
    const whatsappLink = `https://api.whatsapp.com/send?phone=${membershipData?.relationship_manager_contact}&text=${WA_MEMBER_PREMIUM_MESSAGE}`;
    window.location.href = whatsappLink;
  };

  const handleClickDetailPrime = () => {
    return isPremiumTrial
      ? window.open('https://ajaib.co.id/ajaib-prime/')
      : setInfoPrimeData({
          isOpen: true,
          img: membershipData.membership_banner,
          title: '',
          content: <div className={styMembershipModal} dangerouslySetInnerHTML={createMarkup()} />,
        });
  };

  return (
    <div className={styPrimeWrapper}>
      <div className={styPrimeHeader}>
        <div>
          <ICON_PRIME />
        </div>
        <div className={styPrimeRightHeader}>
          {isPremiumTrial && (
            <div className={styPrimeBadgeTrial}>
              Sisa {primeTrialData?.trial_remaining_days} Hari Lagi
            </div>
          )}
          <div onClick={handleClickDetailPrime} style={{ cursor: 'pointer', display: 'flex' }}>
            <IconSvg.Chevron.Right color="#FFFFFF" />
          </div>
        </div>
      </div>
      <div className={styPrimeContent}>
        <div style={{ display: 'flex' }}>
          <img src={primeAvatarImg} alt="" style={{ objectFit: 'contain' }} />
          {isPremiumTrial ? (
            <div className={styPrimeTrialInfo}>
              <span className={styPrimeTrialTitle}>Mulai Terhubung ke Relationship Manager</span>
              <span style={{ fontSize: 12 }}>Konsultasi portofolio dan bantuan khusus Anda.</span>
              <Button
                variant="naked"
                size="xs"
                onClick={() => window.open('https://ajaib.co.id/ajaib-prime/')}
                style={{ padding: 0, fontSize: 12 }}
              >
                Pelajari Lebih Lanjut
              </Button>
            </div>
          ) : (
            <div className={styPrimeManager}>
              <span className={styPrimeText}>Relationship manager</span>
              <span className={styPrimeName}>
                {membershipData?.relationship_manager_name || 'Dalam Proses'}
              </span>
            </div>
          )}
        </div>
        {!isPremiumTrial && (
          <div style={{ display: 'flex', cursor: 'pointer' }} onClick={() => clickToCallRm()}>
            <IconWhatsapp />
          </div>
        )}
      </div>
      <PopupDetail infoPrimeData={infoPrimeData} hideModal={hideModal} />
    </div>
  );
};

Prime.propTypes = {
  membershipData: shape({}),
  isPremiumTrial: bool,
  primeTrialData: shape({}),
};

Prime.defaultProps = {
  membershipData: {},
  isPremiumTrial: false,
  primeTrialData: {},
};

export default Prime;
